import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {MdProgressSpinnerModule} from "../misc/progress-spinner";
import {ErrorModule} from "../errors/error.module";
import {ListEditorService} from "./list-editor.service";
import {ListStructure} from "./list-structure";
import {ModifyListItemDialogComponent} from "./modify-list-item.component";
import {ListDisplayComponent} from "./list-display.component";
import {DatePickerModule} from "../datepicker/datepicker.module";
import {PaginationModule} from "../pagination/pagination.module";
import {ListMoveControlsComponent} from "./list-move-controls.component";
import {ListEditControlsComponent} from "./list-edit-controls.component";

@NgModule({
  providers: [
    ListEditorService,
    ListStructure,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BootstrapModalModule,
    ErrorModule,
    DatePickerModule,
    PaginationModule,
    MdProgressSpinnerModule,
  ],
  declarations: [
    ModifyListItemDialogComponent,
    ListDisplayComponent,
    ListMoveControlsComponent,
    ListEditControlsComponent,
  ],
  exports: [
    ListDisplayComponent,
    ListMoveControlsComponent,
    ListEditControlsComponent,
  ],
  entryComponents: [
    ModifyListItemDialogComponent,
    ListDisplayComponent,
  ],
})

export class ListEditorModule {

}
